/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { actualiteSchema } from "../actualiteSchema.ts";
import { actualiteThemeSchema } from "../actualiteThemeSchema.ts";
import { z } from "zod";

export const getLastActualitesQueryParamsSchema = z.object({
      "theme": z.lazy(() => actualiteThemeSchema).describe("Thématique des actualités :\n- ACTUALITES : Actualités générales\n- IA_NOTARIAT : IA & Notariat\n- VENTES_INTERACTIVES_36_H_IMMO : Les ventes interactives 36h immo\n- CONSEILS_ASTUCES : Conseils et astuces\n").optional()
      }).optional()

/**
 * @description Les informations des actualités sont retournées avec succès.
 */
export const getLastActualites200Schema = z.array(z.lazy(() => actualiteSchema))

/**
 * @description error occurred - see status code and problem object for more information.
 */
export const getLastActualites404Schema = z.object({
      "type": z.string().url().default("about:blank").describe("An absolute URI that identifies the problem type. When dereferenced,\nit SHOULD provide human-readable documentation for the problem type\n(e.g., using HTML).\n"),
  "title": z.string().describe("A short, summary of the problem type. Written in english and readable\nfor engineers (usually not suited for non technical stakeholders and\nnot localized); example: Service Unavailable\n").optional(),
  "status": z.number().int().min(100).max(600).describe("The HTTP status code generated by the origin server for this occurrence\nof the problem.\n").optional(),
  "detail": z.string().describe("A human readable explanation specific to this occurrence of the\nproblem.\n").optional(),
  "instance": z.string().url().describe("An absolute URI that identifies the specific occurrence of the problem.\nIt may or may not yield further information if dereferenced.\n").optional(),
  "properties": z.object({
      
      }).catchall(z.any()).describe("Additional properties that can be used to store any additional information\nabout the problem. This is useful for providing more context or details\nabout the error.\n").optional()
      })

export const getLastActualitesQueryResponseSchema = z.lazy(() => getLastActualites200Schema)